import { render, staticRenderFns } from "./cdethottopic.vue?vue&type=template&id=0109b8f0&"
import script from "./cdethottopic.vue?vue&type=script&lang=js&"
export * from "./cdethottopic.vue?vue&type=script&lang=js&"
import style0 from "./cdethottopic.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports